export default __webpack_public_path__ + "static/pole-3-thumb-b6c0bc8710c96f56be05c16f0b9d749d.png";